import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { DiaryType } from '../../../../../../data/tracker/domain/diary_type/diary_type';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-diary-type-edit-popup',
  templateUrl: './diary-type-edit-popup.component.html',
  styleUrls: ['./diary-type-edit-popup.component.scss'],
})
export class DiaryTypeEditPopupComponent {
  @Input() diaryType: DiaryType;
  @Output() action = new EventEmitter<DiaryType | undefined>();
  public isLoading: boolean;

  constructor(private bsModalRef: BsModalRef) {}

  hideModal() {
    this.bsModalRef.hide();
  }

  validate() {
    this.action.emit(this.diaryType);
    this.hideModal();
  }

  enabledValidate() {
    return (
      this.diaryType.label &&
      this.diaryType.label.length > 0 &&
      this.diaryType.hint &&
      this.diaryType.hint.length > 0
    );
  }
}
